// JS file for EditorialBoardList

const bsCollapse = new bootstrap.Collapse('#editorial-menu-list', {
  toggle: false
})

const menuList = $('#editorial-menu-list');

if (window.matchMedia('(max-width: 991px)').matches) {
  if (menuList.hasClass('show')) {
    bsCollapse.hide();
  }
}
